import type {IAdData} from '../../../definitions';

export function handleSitebarOverlay(data: IAdData): void {
  if (data.target) {
  // Reset sitebar container style
    const sitebarContainer = data.target;
    sitebarContainer.removeAttribute('style');

    // Reset sitebar iframe style
    const iframe = sitebarContainer.getElementsByTagName('iframe')[0];
    iframe.removeAttribute('style');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.width = '100%';
    iframe.height = '100%';

    sitebarContainer.classList.add('ad-sitebar-slideshow');
  }
}

export function adjustSitebarIframe(iframe?: HTMLIFrameElement): void {
  // reset the size of iframe generated by as2
  const ifr = iframe ?? document.querySelector('.ad-sitebar iframe');
  if (ifr) {
    ifr.removeAttribute('style');
  }
}
